import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {TaskDescService} from '../../services/task-desc.service';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/timer';
import * as moment from 'moment';
import {SidebarService} from '../../services/side-bar.service';
import {TaskBarService} from '../../services/task-bar.service';
import {HeaderService} from '../../services/header.service';
import {UserService} from '../../services/user.service';
import {tick} from '@angular/core/testing';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ViewDocxComponent} from '../views/view-docx/view-docx.component';

@Component({
  selector: 'app-home-tasks',
  templateUrl: './home-tasks.component.html',
  styleUrls: ['./home-tasks.component.css']
})
export class HomeTasksComponent implements OnInit {
  public isLoaded = false; // false
  private myTaskList: any[] = [];
  private limiter = 65;
  errorTaskList = false;
  haveTasks = false;

  private delay = 0;
  private timer = 1000 * 60 * 30;

  expiredItemInactive = false;
  activeItemInactive = false;
  oneCItemInactive = false;

  countNewItems = 0;
  countActionItems = 0;
  countExpiredItems = 0;
  countActiveItems = 0;
  countNotAcceptableItems = 0;
  countOneItems = 0;

  constructor(private apiService: ApiService,
              private modalService: NgbModal,
              private taskDescService: TaskDescService,
              public sidebarService: SidebarService,
              private taskBarService: TaskBarService,
              private headerService: HeaderService,
              private userService: UserService) {
  }

  ngOnInit() {
    // MVC:
    if (!this.userService.getLocal().testing) {
      // open sidebar
      this.sidebarService.setSideBar(true);
      // close task bar
      this.taskBarService.closeTaskBar();
      // show sidebar but in header
      this.headerService.showSideMenu();
      // show task bar but in header
      this.headerService.showTaskMenu();
      // show username in header
      this.headerService.showUsername();
    }

    // Observable.timer(this.delay, this.timer).subscribe(() => {
    //   this.apiService.getMyTasks().subscribe(
    //     (response) => {
    //       this.errorTaskList = false;
    //       if (response.status === 200) {
    //         const data: any = response.body;
    //         data.forEach(item => {
    //           if (item.source === '_1C') {
    //             item.source = item.source.substr(1);
    //             item.date = item.date.substr(0, 8);
    //             item.date = moment(item.date).format('YYYY-MM-DD');
    //             item.deadLine = item.deadLine.substr(0, 8);
    //             item.deadLine = moment(item.deadLine).format('YYYY-MM-DD');
    //           }
    //           item.short = item.description;
    //           item.isOpen = false;
    //         });
    //         this.myTaskList = data;

    //         if (this.myTaskList.length > 0) {
    //           this.haveTasks = true;
    //         } else {
    //           this.haveTasks = false;
    //         }
    //         this.isLoaded = true;
    //       }
    //       if (response.status === 204) {
    //         this.haveTasks = false;
    //         this.isLoaded = true;
    //       }
    //     },
    //     () => {
    //       this.isLoaded = true;
    //       this.errorTaskList = true;

    //     }, () => {
    //       if (this.myTaskList.length > 0) {
    //         this.countNewItems = 0;
    //         this.countActionItems = 0;
    //         this.countExpiredItems = 0;
    //         this.countActiveItems = 0;
    //         this.countNotAcceptableItems = 0;
    //         this.countOneItems = 0;

    //         for (const item of this.myTaskList) {
    //           if (item.source === 'PLANFIX') {
    //             switch (item.status) {

    //               case 'EXPIRED':
    //                 this.countExpiredItems++;
    //                 break;

    //               case 'ACTIVE':
    //                 this.countActiveItems++;
    //                 break;

    //             }
    //           } else {
    //             this.countOneItems++;
    //           }
    //         }
    //       }
    //     }
    //   );
    // });

  }

  taskAction(taskInfo) {
    taskInfo.isOpen = !taskInfo.isOpen;
  }

  openFullDesc(taskInfo) {
    this.taskDescService.setModalTaskInfo(
      taskInfo.source,
      taskInfo.number,
      taskInfo.fullDescription,
      taskInfo.author,
      taskInfo.startDate,
      taskInfo.date,
      taskInfo.executor,
      taskInfo.endDate,
      taskInfo.deadLine);
  }

  setItmStatus(s) {
    switch (s) {
      case 'ACTIVE':
        this.activeItemInactive = !this.activeItemInactive;
        break;

      case 'EXPIRED':
        this.expiredItemInactive = !this.expiredItemInactive;
        break;

      case '1C':
        this.oneCItemInactive = !this.oneCItemInactive;
        break;
    }
  }

  hiddeMe(task) {
    if (task.source === '1C') {
      return this.oneCItemInactive;
    } else if (task.source === 'PLANFIX') {
      switch (task.status) {

        case 'EXPIRED':
          return this.expiredItemInactive;

        case 'ACTIVE':
          return this.activeItemInactive;

        case '1C':
          return this.oneCItemInactive;
      }
    }
  }


  // openDocModal() {
  //   // { size: 'lg', backdrop: 'static' }
  //   const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
  // }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/home-tasks/home-tasks.component.ts